<template>
  <div class="obj_push push_promo" :class="{ open: toggleDropdown }">
    <a class="btn_filtrage-promo" @click="toggle">{{ promotionFilterTitle }}</a>
    <div class="ctn_liste-promo">
      <div class="jQueryScroll">
        <ul>
          <li v-for="x in promotionListDatas" :key="x.Title" @click="filterPromotionList(x)">
            <a :class="{ active: x.Title === enabledTitle }" :data-value="x.Title">{{ x.Title }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@refapp/eventbus-js';
import Event from './promotion-banner-event';
import { tryParseJson } from '../mixins/utils';

export default {
  name: 'rfp-storelocator-promotion-list',
  props: {
    promotionFilterTitle: {
      type: String,
      default: 'Filter per promotion',
    },
  },
  data() {
    return {
      promotionListDatas: [],
      toggleDropdown: false,
      enabledTitle: '',
      enabledDescription: '',
      allStoreDatas: [],
      filterDatas: [],
      queryParemsEnabled: false,
      keyValue: false,
      findDatas: {},
    };
  },
  created() {
    this.getPromotionList();
    eventBus.on(Event.QueryParams, (val) => {
      this.toggleDropdown = false;
      if (val != '') {
        this.queryParemsEnabled = true;
      }
    });
    eventBus.on(Event.BannerClosed, () => {
      if (this.getParameter('promotion') != 'no') {
        window.location.href = this.removeParams('promotion');
      }
      this.enabledTitle = '';
    });
    eventBus.on(Event.ListCollection, (values) => {
      this.allStoreDatas = values;
    });
    eventBus.on('rfp_get_promotion_banner_info', () => {
      if (this.getParameter('promotion') != 'no') {
        this.getPromotionList();
      }
    });
    eventBus.on('promotionMapDataClose', () => {
      this.enabledTitle = '';
      this.enabledDescription = '';
      eventBus.emit('promotionBannerClose');
    });
  },
  methods: {
    toggle() {
      this.toggleDropdown = !this.toggleDropdown;
    },
    updateQueryStringParameter(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = uri.indexOf('?') !== -1 ? '&' : '?';
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return uri + separator + key + '=' + value;
      }
    },
    filterPromotionList(data) {
      let newUrl = this.updateQueryStringParameter(window.location.href, 'promotion', data.Code);
      window.history.pushState('', 'Page Title Here', newUrl);
      eventBus.emit(Event.RefreshMapOptions);
      this.enabledDescription = data.Description;
      this.enabledTitle = data.Title;
      eventBus.emit(Event.List, data);
      eventBus.emit(Event.BannerFilter, data.Code);
      this.toggle();
    },
    getPromotionList() {
      fetch('/refapp/storefinder/getactivepromotions')
        .then((resp) => resp.text())
        .then((resp) => {
          this.promotionListDatas = tryParseJson(resp);
          if (this.keyValue) {
            this.findDatas = this.promotionListDatas.find(
              (element) =>
                element.Code.toLowerCase() === this.getParameter('promotion').toLowerCase(),
            );
            if (this.findDatas != undefined) {
              this.enabledDescription = this.findDatas.Description;
              this.enabledTitle = this.findDatas.Title;
              eventBus.emit(Event.List, this.findDatas);
            }
          }
        })
        .catch((error) => {
          console.warn('Promotion list endpoint not connected', error);
        });
    },
    getParameter(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
          this.queryParemsEnabled = true;
          this.keyValue = true;
          return decodeURIComponent(pair[1]);
        } else {
          this.queryParemsEnabled = false;
        }
      }
      this.queryParemsEnabled = false;
      this.keyValue = false;
      return 'no';
    },
    removeParams(sParam) {
      var url = window.location.href.split('?')[0] + '?';
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] != sParam) {
          url = url + sParameterName[0] + '=' + sParameterName[1] + '&';
        }
      }
      return url.substring(0, url.length - 1);
    },
  },
};
</script>
